import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Tag } from 'core/components/tag';
import { Tooltip } from 'core/components/tooltip';
import helpCircleIcon from 'core/assets/svg/help-circle.svg';
import { dateFormatter } from 'core/helpers/formatters';
import { IncidentStatus, incidentStatusLabels } from 'common/helpers/ignored-incidents';
import useStyles from './ignore-incidents.styles';

const PRIOR_CARRIER_TOOLTIP =
  "The prior carrier chose not to count this claim or violation, so it doesn't count here either.";

export const incidentStatusTooltip = ({ status, ignoredBy, ignoredAt }) => {
  if (status === IncidentStatus.Ignored) {
    const by = ignoredBy ? ` by ${ignoredBy}` : '';
    const on = ignoredAt ? ` on ${dateFormatter(ignoredAt.slice(0, 10))}` : '';
    return `Ignored${by}${on}. It doesn't affect price or eligibility.`;
  }
  return status === IncidentStatus.IgnoredByPriorCarrier ? PRIOR_CARRIER_TOOLTIP : null;
};

// The status is always written out; the tooltip's text is also the icon's alt text for screen readers.
const IncidentStatusTag = ({ incident }) => {
  const classes = useStyles();
  const tooltip = incidentStatusTooltip(incident);
  return (
    <span className={classes.statusTag}>
      <Tag className={classNames(classes.tag, { [classes.notCountedTag]: incident.status !== IncidentStatus.Counts })}>
        {incidentStatusLabels[incident.status]}
      </Tag>
      {tooltip && <Tooltip text={tooltip} placement="top" smallIcon={{ src: helpCircleIcon }} iconSize="icon16" />}
    </span>
  );
};

IncidentStatusTag.propTypes = {
  incident: PropTypes.shape({
    status: PropTypes.string.isRequired,
    ignoredBy: PropTypes.string,
    ignoredAt: PropTypes.string
  }).isRequired
};

export default IncidentStatusTag;
